"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _ScopedFeatureTooltip = _interopRequireDefault(require("./permissions/ScopedFeatureTooltip"));

var _canvaLogo = _interopRequireDefault(require("bender-url!FileManagerImages/images/canva-logo.png"));

var CanvaCreateDisabledButton = function CanvaCreateDisabledButton() {
  return _react.default.createElement(_ScopedFeatureTooltip.default, null, _react.default.createElement(_UIButton.default, {
    disabled: true
  }, _react.default.createElement(_UIImage.default, {
    alt: _I18n.default.text('FileManagerCore.actions.addFromCanva'),
    className: "m-x-1",
    height: 20,
    responsive: false,
    src: _canvaLogo.default
  }), _react.default.createElement(_FormattedMessage.default, {
    className: "canva-button-text m-x-1",
    message: "FileManagerCore.actions.addFromCanva"
  })));
};

var _default = CanvaCreateDisabledButton;
exports.default = _default;
module.exports = exports.default;